// extracted by mini-css-extract-plugin
module.exports = {"user-details-card":"sTs_2","user-details-card__header":"_33XEi","user-details__space":"_35zZ_","user-details__title":"_2TKss","user-details__value":"NgSum"};